.tooltipContent {
  z-index: var(--z-index-layer-tooltip);
  overflow: hidden;
  max-width: var(--tooltip-max-width);
  padding: var(--spacing-sm) var(--spacing-md);
  border-radius: var(--radius-lg);
  font: var(--body-sm-font);
  border: var(--border-width-default) solid var(--border-default);
  animation: tooltipFadeIn 200ms ease-out;
  transform-origin: var(--radix-tooltip-content-transform-origin);
}

.insideModal {
  z-index: var(--z-index-layer-popover-inside-modal);
}

.themeInverted {
  background-color: var(--surface-inverse);
  color: var(--content-inverse);
}

.themeMatching {
  background-color: var(--surface-raised);
  color: var(--content-primary);
}

.breakWord {
  overflow-wrap: break-word;
}

/* Only when the caller passed `onContentClick`, so the cursor doesn't promise an
   interaction on the ordinary label tooltips. */
.clickable {
  cursor: pointer;
}

.arrow {
  fill: var(--surface-inverse);
}

.themeMatching .arrow {
  fill: var(--surface-raised);
}

/* stylelint-disable-next-line keyframes-name-pattern */
@keyframes tooltipFadeIn {
  0% {
    opacity: 0;
    transform: scale(0.96);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}
